import classNames from "./Toggle.module.css";

// Use for just rendering mic toggle
export const StatelessToggle = (props: {
  enabled: boolean;
  noPointer?: boolean;
}) => {
  return (
    <label
      className={`${classNames.Toggle} ${
        props.noPointer ? classNames.NoPointer : ""
      }`}
    >
      <div aria-checked={props.enabled} />
      <span className={classNames.Slider}></span>
    </label>
  );
};

export default function Toggle(props: {
  enabled: boolean;
  onChange: (value: boolean) => void;
}) {
  return (
    <label className={classNames.Toggle}>
      <input
        type="checkbox"
        checked={props.enabled}
        onChange={() => props.onChange(!props.enabled)}
      />
      <span className={classNames.Slider}></span>
    </label>
  );
}
